import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class InterceptohttpInterceptor implements HttpInterceptor {
  private readonly tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
  
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get the user token from local storage by checking all possible keys
    let token = null;
    for (const key of this.tokenKeys) {
      token = localStorage.getItem(key);
      if (token) break;
    }
    
    // Clone the request to modify it
    let modifiedRequest = request;

    // If a token exists, set the Authorization header
    if (token) {
      modifiedRequest = request.clone({
        setHeaders: { 
          Authorization: token // Add 'Bearer ' prefix if your backend expects it
        },
      });
    }

    // Pass the modified request to the next handler in the chain
    return next.handle(modifiedRequest);
  }
}